import {ActionTypes} from "./types";
import axios from "axios";
import {getAccessToken} from "../../auth/auth";

const host = process.env.REACT_APP_HOST

export const search  = (queryParams) =>{
  const config = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    },
    params: queryParams
  }

  return async dispatch => {
    return axios.get(`${host}/voucher`, config)
      .then(
        response =>dispatch(setVouchers(response.data)),
        err => console.log(err)
      );
  }
}

export const setVouchers = (payload) => ({
  type: ActionTypes.SET_VOUCHERS,
  payload: payload,
});